import { Box, Button, Grid, Link } from "@mui/material";
import classes from '../../Style/ReportingCountry.scss';
import HorizontalBarChart from "../Charts/HorizontalBarChart";
import SampleOriginDistribution from "./SampleOriginDistribution";
import csv1 from '../../Data/MANCP/Geospatial/MANCP-Sample-origin-per-country-of-sampling.csv'
import csv2 from '../../Data/MANCP/Pesticides/MANCP-Frequency-of-MRL-exceedances-per-pesticide.csv';
import FrequencyDataGrid from "./FrequencyDataGrid";
import csv3 from '../../Data/MANCP/Pesticides/MANCP-Distribution-of-quantified-results-per-sample.csv';
import HistogramChart from "../Charts/HistogramChart";
import csv4 from '../../Data/MANCP/Pesticides/MANCP-Results-on-import-control-samples-under-Regulation-2019-1793.csv';
import FilteredDataGrid from "./FilteredDataGrid";
import ButtonsSelect from "../Common/ButtonsSelect";
import csv5 from '../../Data/MANCP/FoodProduct/MANCP-Results-with-quantified-residues-legal-limit-legal-limit-and-non-compliant-Processed.csv';
import csv6 from '../../Data/MANCP/FoodProduct/MANCP-Results-with-quantified-residues-legal-limit-legal-limit-and-non-compliant-Unprocessed.csv';
import { useContext, useState, useRef, useEffect } from "react";
import HorizontalBarChartWithNegative from "../Charts/HorizontalBarChartWithNegative";
import DodgeBarChart from "../Charts/DodgeBarChart";
import csv7 from '../../Data/MANCP/FoodProduct/MANCP-Comparison-of-organic-and-conventional-products-Grouped-bar-chart.csv';
import TreeMapChart from "./TreeMapChart";
import csv8 from '../../Data/MANCP/FoodProduct/MANCP-Number-of-different-pesticides-found-in-each-animal-food-group.csv';
import GradientColumnsChart from "../Charts/GradientColumnsChart";
import FeedResults from "./FeedResults";
import DottedGraph from "./DottedGraph";
import ReportingCountryMap from "../Maps/ReportingCountryMap";
import mapJSON from '../../Data/JSON/ChapterOneMap.json';
import mapCSV from '../../Data/MANCP/Geospatial/MANCP-Reporting-country.csv';
import SamplesFilter from "./SamplesFilter";
import BoxPlotChart from "../Charts/BoxPlotChart";
import MenuContext from "../../store/menu-context";
import CustomLink from "../Common/CustomLink";
import ModalTrigger from "../Common/ModalTrigger";
import TreeMapMobileChart from "./TreeMapMobileChart";
import FeedResultsMobile from "./FeedResultsMobile";
import DottedGraphMobile from "./DottedGraphMobile";
import processed from '../../Assets/processed-1.png';
import unprocessed from '../../Assets/unprocessed-1.png';


const ReportingCountry = () => {

    const anchorOne = useRef(null)
    const anchorTwo = useRef(null)
    const anchorThree = useRef(null)

    const fields = [
        "Below quantification limit %",
        "Between quantification limit and Legal Limit %",
        "Above Legal Limit %",
        "Non-compliant %"
    ];
    const colorMap = {
        "Below quantification limit %": "#00B289",
        "Between quantification limit and Legal Limit %": "#9CDCCE",
        "Above Legal Limit %": "#FFCE3A",
        "Non-compliant %": "#EF9800"
    };


    const filters = [
        'Number of samples',
        'Number of samples per 100k inhabitants',
        'Difference in samples from past year (%)',
        'Rate of samples below LOQ',
        'Rate of samples between LOQ and MRL',
        'Rate of quantification',
        'Rate of non-compliant samples',
        'Rate of samples above legal limit',
    ]

    const retained = 'Food commodity';

    const [processedFoodCSV, setProcessedFoodCSV] = useState(csv5);
    const [comparisonFilter, setComparisonFilter] = useState(0);
    const [processedStatus, setProcessedStatus] = useState(0);
    const handleButtonClick = (event) => {
        setProcessedStatus(event);
        if (event === 0) {
            setProcessedFoodCSV(csv5);
        } else {
            setProcessedFoodCSV(csv6);
        }
    }

    const comparisonFilterHandler = (event) => {
        setComparisonFilter(event);
    }

    const [samplesFilter, setSamplesFilter] = useState(filters[0]);

    const handleFilterChange = (evt) => {
        setSamplesFilter(evt);
    }

    const ctx = useContext(MenuContext);
    if (!ctx.scrollEnabled && anchorOne.current !== null) {
        if (ctx.index === 0) {
            window.scrollTo({ top: anchorOne.current.offsetTop - 100, left: 0, behavior: 'smooth' });
        } else if (ctx.index === 1) {
            window.scrollTo({ top: anchorTwo.current.offsetTop - 100, left: 0, behavior: 'smooth' });
        } else if (ctx.index === 2) {
            window.scrollTo({ top: anchorThree.current.offsetTop - 100, left: 0, behavior: 'smooth' });
        }
    }


    const handleScroll = (e) => {
        const scrollTop = e.srcElement.firstElementChild.scrollTop;
        if (anchorTwo.current !== null && scrollTop >= 0 && scrollTop < anchorTwo.current.offsetTop) {
            if (ctx.index !== 0) {
                ctx.updateContext(0, true);
            }
        } else if (anchorTwo.current !== null && scrollTop >= anchorTwo.current.offsetTop - 100 && scrollTop < anchorThree.current.offsetTop - 100) {
            if (ctx.index !== 1) {
                ctx.updateContext(1, true);
            }
        } else if (anchorThree.current !== null && scrollTop >= anchorThree.current.offsetTop - 100) {
            if (ctx.index !== 2) {
                ctx.updateContext(2, true);

            }
        }
    }


    useEffect(() => {
        window.addEventListener("scroll", (e) => handleScroll(e));
        return () => {
            window.removeEventListener("scroll", (e) => handleScroll(e));
        };
    }, []);

    return (
        <Grid container direction="column" className="reportingCountryWrapper">
            {/* First row */}
            <Grid ref={anchorOne} item container direction={{ xs: 'column', sm: 'column', md: 'row' }} sx={{ marginTop: { xs: '50px', sm: '50px', md: '90px' } }}>
                <Grid item xs p={3} className="one-one">
                    <Box>
                        <span>EU MCAP RESULTS</span>
                        <h3>Reporting country findings</h3>
                        <p>In 2020, a total of 88,141 samples of food products covered by <CustomLink text='Regulation (EC) No 396/2005' href='https://www.google.com/url?q=https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri%3DCELEX:32005R0396%26from%3DEN&sa=D&source=docs&ust=1645465497477169&usg=AOvVaw1id26IeMa1HZQXAfMo0nBI' /> were analysed for pesticide residues by 30 reporting countries. The total number of samples analysed decreased by 9.3% compared to 2019 (96,302 samples). Additionally, 11 countries reported 1,379 feed samples and 962 fish samples.</p>
                    </Box>
                    <Box>
                        <SamplesFilter title='Number of samples' filters={filters} onFilterChange={handleFilterChange} />
                    </Box>
                </Grid>
                <Grid item xs p={3} className="one-two">
                    <ReportingCountryMap csv={mapCSV} samplesFilter={samplesFilter} json={mapJSON} />
                </Grid>
            </Grid>
            {/* First row */}

            {/* Second row */}
            <Grid item container direction={{ xs: 'column', sm: 'column', md: 'row' }} sx={{ marginTop: { xs: '50px', sm: '50px', md: '90px' } }}>
                <Grid item xs p={3} className="two-one">
                    <Box>
                        <h3>Sampling region by reporting countries</h3>
                        <p>Of the 59,026 samples originating in the reporting countries, 41.3% were found to be below the LOQ while 24.1% contained residues <ModalTrigger text='at or above the LOQ but below or equal to the MRL' />; 1.6% of the samples exceeded the MRL and 0.9% were non-compliant with the MRL.  Samples imported from third countries (25,014 samples) were found to have a higher MRL exceedance rate (3.3%) and a higher non-compliance level (2.6%) compared to food produced within the EU. The percentage of samples from third countries without quantifiable residues was 10.8% while the percentage of samples containing <ModalTrigger text='quantifiable residues' /> within the legal limits was 14.2%. The remaining 4.7% (4,101 samples) were reported as origin unknown. </p>
                    </Box>
                    <Box>
                        <SampleOriginDistribution />
                    </Box>
                </Grid>
                <Grid item xs p={3} className="two-two">
                    <HorizontalBarChart csv={csv1}
                        title='Sample origin % per country of sampling'
                        yField='country'
                        xField='value'
                        transform={true}
                        stackField='region' />
                </Grid>
            </Grid>
            {/* Second row */}

            {/* Third row */}
            <Grid ref={anchorTwo} item container direction={{ xs: 'column', sm: 'column', md: 'row' }} sx={{ marginTop: { xs: '50px', sm: '50px', md: '70px' } }}>
                <Grid item xs p={3} className="three-one" pt={7} pb={7} pl={4} pr={4} sx={{ maxHeight: { xs: 'auto', sm: 'auto', md: '790px' } }}>
                    <Box>
                        <h3>Results by pesticide residues</h3>
                        <p>Overall, 94.9% of the 88,141 samples analysed in 2020 fell within legal limits (83,666 samples); of these, 48,181 samples (54.6%) did not contain <ModalTrigger text='quantifiable residues' /> (results <ModalTrigger text='below the LOQ' /> for all pesticides analysed) while 40.3% of the samples analysed contained quantified residues not exceeding legal limits (35,485 samples).  In total, <ModalTrigger text='MRLs' /> were exceeded in 5.1% of the samples analysed (4,475 samples), an increase of 1.2 percentage points on 2019 (3.9%; 3,720 samples).</p>
                        <p>When taking into account the measurement uncertainty that is implemented by food regulatory authorities across Europe, 3.6% of all samples analysed in 2020 (3,156 samples) exceeded legal limits, triggering legal sanctions or enforcement actions (compared with 2.3% in 2019). Samples with clear exceedances or breaches of MRLs are considered non-compliant with legal limits.</p>
                        <p>Of the 88,141 samples analysed, 39,960 (45.3%) contained one or several pesticides in quantifiable concentrations (compared with 43.4% in 2019). Multiple residues were reported in 24,057 samples (27% - the same as in 2019); up to 35 different pesticides were reported in a single strawberry sample of unknown origin.</p>
                    </Box>
                </Grid>
                <Grid item xs p={3} className="three-two">
                    <Box>
                        <FrequencyDataGrid title='Frequency of MRL exceedances per pesticide' csv={csv2} />
                    </Box>
                    <Box>
                        <BoxPlotChart title='Distribution of number of results per sample' csv={csv3} />
                        <HistogramChart csv={csv3} />
                    </Box>
                </Grid>
            </Grid>
            {/* Third row */}

            {/* Fourth row */}
            <Grid flexWrap='nowrap' item container direction={{ xs: 'column', sm: 'column', md: 'row' }} sx={{ backgroundColor: '#FAFAFA', marginTop: { xs: '50px', sm: '50px', md: '70px' } }}>
                <Grid item xs p={3} className="four-one">
                    <Box>
                        <h3>Focus on glyphosate</h3>
                        <p>Glyphosate is approved for use in the EU until 15 December 2022. <CustomLink href='https://www.google.com/url?q=https://ec.europa.eu/food/plants/pesticides/approval-active-substances/renewal-approval/glyphosate_en%23:~:text%3DGlyphosate%2520is%2520currently%2520approved%2520in,an%2520evaluation%2520of%2520its%2520safety&sa=D&source=docs&ust=1645465497473839&usg=AOvVaw145Y2bqYeXaT78neSEl54H' text='The EU re-evaluation of glyphosate is ongoing' />. All interested parties had access to the joint scientific evaluations prepared by the national competent authorities of Hungary, France, the Netherlands and Sweden. The main findings in 2020, when glyphosate was analysed by 27 reporting countries are as follows: Overall, 14,125 samples of different food products and 474 samples of animal feed were analysed for glyphosate residues. In 97.4% of the samples (13,760), glyphosate was not quantified. In 2% of the samples (283), glyphosate was quantified at levels <ModalTrigger text='above the LOQ but below the MRL' />. And in 82 samples (0.6%), the residue levels exceeded the MRL. The exceedance rate was higher than in 2019 (0.1%).</p>
                        <p>Taking into account the measurement uncertainty, 56 samples (0.4%) were non-compliant. Glyphosate residues were analysed in 262 baby food samples. The MRL was exceeded in one sample of processed cereal-based foods for infants and young children.</p>
                        <p>AMPA, a metabolite of glyphosate, was analysed in 4,534 food samples and 242 feed samples. In food, AMPA was quantified in 0.2% of the samples (4 samples of pulses, 5 of cereals, 1 of oranges and 1 of onions). In feed it was quantified in 31 samples (12.8%).</p>
                    </Box>
                </Grid>
                <Grid item xs p={3} className="four-two" display='flex' alignItems='flex-start'>
                    <Box sx={{ display: { xs: 'none', sm: 'none', md: 'block' }, width: '100%', maxHeight: '500px', maxWidth: '600px' }} display='flex'>
                        <FeedResults />
                    </Box>
                    <Box sx={{ display: { xs: 'block', sm: 'block', md: 'none' }, width: '100%', maxHeight: '600px', maxWidth: '600px' }} display='flex'>
                        <FeedResultsMobile />
                    </Box>
                </Grid>
            </Grid>
            {/* Fourth row */}

            {/* Fifth row */}
            <Grid item container direction={{ xs: 'column', sm: 'column', md: 'row' }} sx={{ marginTop: { xs: '50px', sm: '50px', md: '140px' } }}>
                <Grid item xs p={3} className="five-one">
                    <Box>
                        <h3>Results for import control samples under Regulation 2019/1793</h3>
                        <p>According to the provisions of <CustomLink text='Regulation (EU) 2019/179320' href='https://www.google.com/url?q=https://eur-lex.europa.eu/legal-content/en/TXT/?uri%3DCELEX:32019R1793&sa=D&source=docs&ust=1645465497478976&usg=AOvVaw1b4U0MfehT7qpAdgixvZGx' /> on import controls, certain foods were subject to an increased frequency of official controls for certain pesticides at the point of entry into the EU. Overall, 9,275 samples were reported. Of those, 16.5% (1,529 samples) were considered non-compliant with EU legislation on pesticide residues.</p>
                        <p>Regarding food commodity and country of origin combinations, those combinations above a 10% <ModalTrigger text='non-compliance rate' /> were: grape leaves and similar species from Turkey (55.6%), chilli peppers from Vietnam (50%), pomegranates from Turkey (38%), chilli peppers from India (33%),  oranges from Turkey (27%), mandarins from Turkey (26%), yard-long beans from Dominican Republic (25%), breadfruits from Malaysia (17%), chilli peppers from Uganda (14%), sweet peppers from Turkey (14%), sesame seeds from India (12%) and lemons from Turkey (11%).</p>
                    </Box>
                </Grid>
                <Grid item xs p={3} className="five-two">
                    <FilteredDataGrid csv={csv4} />
                </Grid>
            </Grid>
            {/* Fifth row */}

            {/* Sixth row */}
            <Grid ref={anchorThree} item container direction='column' sx={{ marginTop: { xs: '50px', sm: '50px', md: '140px' } }} alignContent="center">
                <Grid item xs p={3} className="six-one">
                    <Box className="sixth-one-inner">
                        <h3>Results for processed food products</h3>
                        <p>Of the 88,141 samples, 8,559 (9.7%) were reported as processed food. Compliance of these products is checked against MRLs in the raw agricultural commodity after applying a processing factor. The highest <ModalTrigger text='MRL exceedance rates' /> for those processed food products with more than 10 samples reported were in grape leaves and similar species (74%), Brazil nuts (25%), sweet peppers/bell peppers paprika powder (23%) and dried wild fungi (22%). For unprocessed food products the highest MRL exceedance rates were for grape leaves (56%), cumin seed (48%), maté (45%) and wild terrestrial vertebrate animals mainly deer and boar (41%).</p>
                    </Box>
                </Grid>
                <Grid item xs p={3} className="six-two">
                    <Box>
                        <ButtonsSelect firstButton='Processed' secondButton='Unprocessed' onButtonClick={handleButtonClick} />
                        <Box display='flex' flexDirection={{ xs: 'column', sm: 'column', md: 'row' }}>
                            <Box flexGrow={3} order={{ xs: 2, sm: 2, md: 1 }}>
                                <HorizontalBarChartWithNegative title={'Results with quantified residues ≤legal limit, >legal limit and non-compliant'} colorMap={colorMap} fields={fields} retained={retained} csv={processedFoodCSV} />
                            </Box>
                            <Box flexGrow={1} order={{ xs: 1, sm: 1, md: 2 }} sx={{ width: { xs: '100%', sm: '100%', md: '250px' } }}>
                                <HorizontalBarChartWithNegative title={'Results with quantified residues ≤legal limit, >legal limit and non-compliant'} chartImg={processedStatus === 0 ? processed : unprocessed} colorMap={colorMap} fields={['Non-compliant %']} retained={retained} csv={processedFoodCSV} />
                            </Box>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
            {/* Sixth row */}

            {/* Seventh row */}
            <Grid item container direction={{ xs: 'column', sm: 'column', md: 'row' }} sx={{ marginTop: { xs: '50px', sm: '50px', md: '140px' } }}>
                <Grid item xs p={3} className="seven-one">
                    <Box>
                        <h3>Results for organic food products</h3>
                        <p>No specific MRLs are established for organic products. The MRLs set in Regulation (EC) No 396/2005 apply equally to organic food and to conventional food. However, Article 5 of <CustomLink text='Regulation (EC) No 889/2008' href='https://www.google.com/url?q=https://eur-lex.europa.eu/legal-content/EN/TXT/?uri%3Dcelex%253A32008R0889&sa=D&source=docs&ust=1645465497465031&usg=AOvVaw3DemIIYVwIFjs2FinDQz-0' /> on organic production of agricultural products defines restrictions in place for the use of plant protection products.</p>
                        <p>In 2020, 5,783 samples of organic food (excluding baby food) were analysed, corresponding to 6.5% of the total, a slight increase on 2019 (6.2%). Of those, 2,018 samples were reported under the <ModalTrigger text='EU MACP' />. Overall, 4,632 samples flagged as organic did not contain <ModalTrigger text='quantifiable residues' /> (80.1% of the analysed samples vs 86.9% in 2019); 1,064 samples contained quantified residues below or at the MRL level (18.4% vs 11.8% in 2019) and 87 samples were reported with residue levels above their corresponding MRLs (1.5% vs 1.3% in 2019), of which 0.6% (36 samples) were <ModalTrigger text='non-compliant' />.</p>
                        <p>The pesticides with a higher frequency of detections were copper compounds (RD), chlorates (RD) and chlorpyrifos (RD). Compared to conventionally produced food (non-organic), the MRL exceedance and quantification rate trends are generally lower in organic food. This tendency continued in 2020. </p>
                    </Box>
                </Grid>
                <Grid item xs p={3} sx={{ width: '100%' }} className="seven-two">
                    <Box>
                        <ButtonsSelect onButtonClick={comparisonFilterHandler} firstButton='≤MRL' secondButton='>MRL' />
                        <DodgeBarChart csv={csv7} title='Comparison of organic and conventional products' comparisonFilter={comparisonFilter} />
                    </Box>
                </Grid>
            </Grid>
            {/* Seventh row */}

            {/* Eighth row */}
            <Grid flexWrap='nowrap' item container direction={{ xs: 'column', sm: 'column', md: 'row' }} sx={{ marginTop: { xs: '50px', sm: '50px', md: '140px' } }}>
                <Grid item xs p={3} className="eight-one">
                    <Box sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
                        <TreeMapChart title='Number of samples per infants and young children food products' />
                    </Box>
                    <Box sx={{ display: { xs: 'block', sm: 'block', md: 'none' } }}>
                        <TreeMapMobileChart title='Number of samples per infants and young children food products' />
                    </Box>
                </Grid>
                <Grid item xs p={3} className="eight-two">
                    <Box>
                        <h3>Results on baby food</h3>
                        <p>Reporting countries analysed 1,641 samples of baby food. The types of samples were: 580 baby foods other than processed cereal-based food samples, 305 follow-on formulae samples, 395 infant formulae samples and 361 processed cereal-based foods for infants and young children. Of the total number of baby food samples analysed, 413 were flagged as organic and other 413 samples were flagged as EU MACP.</p>
                    </Box>
                </Grid>
            </Grid>
            {/* Eighth row */}

            {/* Ninth row */}
            <Grid item container direction='column' sx={{ marginTop: { xs: '50px', sm: '50px', md: '140px' } }} alignContent="center">
                <Grid item xs p={3} className="nine-one">
                    <Box className="nine-one-inner">
                        <h3>Results for animal products</h3>
                        <p>Overall, 12,142 samples of animal products were reported.</p>
                        <p>A total of 12,142 samples of animal products were reported. The results showed that 11,167 samples were free of quantifiable residues (92.0% vs 91.2% in 2019) while 830 (6.8% vs 8.8% in 2019) contained one or several pesticides in quantifiable concentrations. MRL exceedances were identified in 145 samples (1.2% vs 0.6% in 2019 vs 1.7% in 2018), of which 94 (0.8%) were deemed non-compliant when measurement uncertainty was taken into account.</p>
                    </Box>
                </Grid>
                <Grid item xs p={3} className="nine-two">
                    <GradientColumnsChart csv={csv8} title='Number of different pesticides found in each animal food group' />
                </Grid>
            </Grid>
            {/* Ninth row */}

            {/* Tenth row */}
            <Grid flexWrap='nowrap' item container direction={{ xs: 'column', sm: 'column', md: 'row' }} sx={{ marginTop: { xs: '50px', sm: '50px', md: '140px' } }}>
                <Grid item xs p={3} className="ten-one">
                    <Box>
                        <h3>Results on animal products - fish</h3>
                        <p>Despite no MRLs are applicable to fish under <CustomLink text='Regulation (EC) No 396/2005' href='https://www.google.com/url?q=https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri%3DCELEX:32005R0396%26from%3DEN&sa=D&source=docs&ust=1645465497481635&usg=AOvVaw3leRORSch8I2hs-I1Dg74r' />, 962 fish samples were reported covering an analytical scope of 318 pesticides. 61 samples (6.3%) were reported to have pesticide residue levels quantified at or above the limit of quantification.</p>
                    </Box>
                </Grid>
                <Grid item xs p={3} className="ten-two">
                    <Box display={{ xs: 'none', sm: 'none', md: 'block' }}>
                        <DottedGraph />

                    </Box>
                    <Box display={{ xs: 'block', sm: 'block', md: 'none' }}>
                        <DottedGraphMobile />
                    </Box>
                </Grid>
            </Grid>
            {/* Tenth row */}

            {/* Eleventh row */}
            <Grid item container direction='column' sx={{ marginTop: { xs: '50px', sm: '50px', md: '165px' } }} alignContent="center">
                <Grid item xs p={3} className="-one">
                    <Box className="nine-one-inner">
                        <p><b>Read more about the 2020 results</b></p>
                        <Button className="footerButton" variant="outlined" component={Link} target='_blank' href='http://www.efsa.europa.eu/en/efsajournal/pub/7215' rel="noreferrer">SCIENTIFIC REPORT</Button>
                    </Box>
                </Grid>
            </Grid>
            {/* Eleventh row */}
        </Grid >
    );
}

export default ReportingCountry;
